import {SVGProps} from 'react';

const Icon = (props: SVGProps<SVGSVGElement>) => (
    <svg
        fill="none"
        height="24"
        viewBox="0 0 24 24"
        width="24"
        xmlns="http://www.w3.org/2000/svg"
        {...props}
    >
        <path
            clipRule="evenodd"
            d="M4.25 6.5C4.25 5.25736 5.25736 4.25 6.5 4.25H15C15.4142 4.25 15.75 3.91421 15.75 3.5C15.75 3.08579 15.4142 2.75 15 2.75H6.5C4.42893 2.75 2.75 4.42893 2.75 6.5V17.5C2.75 19.5711 4.42893 21.25 6.5 21.25H17.5C19.5711 21.25 21.25 19.5711 21.25 17.5V11.25C21.25 10.8358 20.9142 10.5 20.5 10.5C20.0858 10.5 19.75 10.8358 19.75 11.25V17.5C19.75 18.7426 18.7426 19.75 17.5 19.75H6.5C5.25736 19.75 4.25 18.7426 4.25 17.5V6.5ZM20.7803 6.28033C21.0732 5.98744 21.0732 5.51256 20.7803 5.21967C20.4874 4.92678 20.0126 4.92678 19.7197 5.21967L10.5 14.4393L8.03033 11.9697C7.73744 11.6768 7.26256 11.6768 6.96967 11.9697C6.67678 12.2626 6.67678 12.7374 6.96967 13.0303L9.89896 15.9596C10.2309 16.2916 10.7691 16.2916 11.101 15.9596L20.7803 6.28033Z"
            fill="currentColor"
            fillRule="evenodd"
        />
    </svg>
);

export default Icon;
